import { UrlProvider } from "lib/UrlProvider";
import { ILoginProvider } from "./ILoginProvider";
import { LoginResponse } from "../Model";
import { Browser } from '@capacitor/browser';
import { App } from '@capacitor/app';
import { AuthenticationStore } from "../AuthenticationStore";
export class AppleAndroidLoginProvider implements ILoginProvider {
    getName = () => "AppleAndroidLoginProvider";

    login(): Promise<LoginResponse> {
        return new Promise(async (resolve, reject) => {
            let appListener: any | null = null;
            let browserListener: any | null = null;

            const handleUrl = async (url: string) => {
                const prefix = "linkstacks://apple/?token=";
                if (url?.startsWith(prefix)) {
                    const tokenId = url.substring(prefix.length);
                    try {
                        await Browser.close();
                    } catch (err) {
                        console.warn("Browser close failed", err);
                    }

                    const response = await fetch(`${new UrlProvider().root}/api/external-login/apple`, {
                        method: "POST",
                        credentials: "include",
                        headers: {
                            "content-type": "application/json"
                        },
                        body: JSON.stringify({ TokenId: tokenId })
                    });

                    if (!response.ok) return reject("Failed to authenticate with Apple");

                    const data = await response.json() as LoginResponse;

                    // the promise callback does not work, so we do this
                    AuthenticationStore.instance.handleLoginResponse(data);
                    //resolve(data);
                }
            };

            try {
                // Listen for when the app is resumed from Browser
                appListener = App.addListener('appUrlOpen', ({ url }) => handleUrl(url));

                browserListener = Browser.addListener('browserFinished', () => {
                    browserListener?.remove();
                    appListener?.remove();
                    reject("User closed the browser");
                });

                // Start Apple login flow
                await Browser.open({
                    url: `${new UrlProvider().root}/api/external-login/apple`
                });

                // ALSO check launch url (cold start)
                const launch = await App.getLaunchUrl();
                if (launch?.url) await handleUrl(launch.url);

            } catch (error) {
                reject("Apple login failed: " + error);
            }
        });
    }
}


interface AuthResponse {
    authorization: Authorization
}

interface Authorization {
    code: string;
    id_token: string;
}


// console.log("launch");

// const checkAppLaunchUrl = async () => {
//     const { url } = await App.getLaunchUrl();

//     console.log('App opened with URL: ' + url);
// };

// checkAppLaunchUrl();